import { Box, FormControl, FormControlLabel, Radio } from '@mui/material';
import { UniOption } from '../../dao/UniOption'
import Label from '../../../libs/rhf-mui/ui/Label';
import { Lang, SpwkUtil } from '../../dao/SpwkUtil';
import RhfCheck from '../../../libs/rhf-mui/RhfCheck';
import UcOptionLabel from '../../components/uni/UcOptionLabel';
import { Member } from '../../dao/Member';

type Props = {
  option: UniOption;
  member: Member | null | undefined;
  LangA: Lang;
  LangB: Lang;
}

const UcOption = ({ option, member, LangA, LangB, ...props }: Props) => {

  const key = option.guid;
  const chk_name = option.get_Option_RhfName();

  let xs_w: string = "";
  if (option.OwnerQuestion?.xs_opt_w === "") {
    xs_w = "100%";
  } else if (option.OwnerQuestion?.xs_opt_w === "auto") {
    xs_w = "";
  } else {
    xs_w = option.OwnerQuestion?.xs_opt_w ?? "";
  }

  const sm_w = option.OwnerQuestion?.sm_opt_w;

  const label = <UcOptionLabel uni_option={option} member={member}
    LangA={LangA}
    LangB={LangB}
  />;


  function render_多選項目() {

    // 修正對齊問題: https://stackoverflow.com/questions/60882578/how-to-vertical-align-material-ui-checkbox
    return (
      <FormControl sx={{ minWidth: { xs: xs_w, sm: sm_w } }}>
        <FormControlLabel
          sx={{ alignItems: 'flex-start' }}
          control={<RhfCheck key={key} name={chk_name} sx={{
            marginTop: option.HasInputs() ? "0px" : "0px",
          }} />}
          label={label}
        />
      </FormControl>
    );
  }

  if (option.OwnerQuestion?.kind === SpwkUtil.KIND_多選) {
    return render_多選項目();
  } else if (option.OwnerQuestion?.kind === SpwkUtil.KIND_單選) {
    // 修正對齊問題: https://stackoverflow.com/questions/60882578/how-to-vertical-align-material-ui-checkbox
    return (
      <FormControl sx={{ minWidth: { xs: xs_w, sm: sm_w } }}>
        <FormControlLabel
          sx={{ alignItems: 'flex-start' }}
          control={<Radio key={key} value={option.option_code} sx={{
            marginTop: option.HasInputs() ? "0px" : "0px",
          }} />}
          label={label}
        />
      </FormControl>
    );
  } else if (option.OwnerQuestion?.kind === SpwkUtil.KIND_非選) {
    return (
      <Box key={key} sx={{
        pl: "0px", p: 0.5,
        minWidth: { xs: xs_w, sm: sm_w }
      }
      }
      >
        {label}
      </Box >
    );

  } else {
    return <Label key={key} color='error'>Unknown KIND</Label>
  }

}




export default UcOption